import { render, staticRenderFns } from "./HistoricDetail.vue?vue&type=template&id=094027eb"
import script from "./HistoricDetail.vue?vue&type=script&lang=js"
export * from "./HistoricDetail.vue?vue&type=script&lang=js"
import style1 from "./HistoricDetail.vue?vue&type=style&index=1&id=094027eb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports